import axios from "axios";
import { 
  CONTRACT_CONDITION_SELECTED,
  EDIT_CONTRACT_CONDITION_MODE,
  ADD_CONTRACT_CONDITION_MODE,
  DELETE_CONTRACT_CONDITION_MODE,
  GET_CONTRACTS_CONDITIONS_DATA,
  GET_CONTRACTS_CONDITIONS,
  CREATE_CONTRACT_CONDITION,
  MOD_CONTRACT_CONDITION,
  DELETE_CONTRACT_CONDITION,
  RESET_CONTRACT_CONDITION_SELECTED,
  CLEAR_CONTRACTS_CONDITIONS,
  CLEAR_ONLY_CONTRACTS_CONDITIONS
} from "../../reducers/contractsConditionsCatalog/contractsConditionsCatalogReducer";
import { START_REQUEST_SEARCH, STOP_REQUEST_SEARCH, SET_SNACKBAR_SEARCH } from "../../reducers/search/searchReducer";

export const getContractsConditionsData = ( token ) => {
  const url = `${process.env.REACT_APP_URL}/crm/contracts_conditions/catalogsConditions`;
  const headers = { Authorization: token };
  let payload = {};
  return async( dispatch ) => {
    dispatch({ type: START_REQUEST_SEARCH });

    await axios.get(url, { headers }).then(resp => {
      payload = {
        type: GET_CONTRACTS_CONDITIONS_DATA,
        payload: resp.data
      };
      dispatch(payload);
    }).catch(error => {
      const err = error.response?.data?.message.error;
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: {
          message: err ? err : "Error contacte al administrador",
          color: 'danger'
        }
      });
    });
    dispatch({ type: STOP_REQUEST_SEARCH });
  };
};

export const getContractsConditions = ( token, stationID ) => {
  const url = `${process.env.REACT_APP_URL}/crm/contracts_conditions/stations/?idStation=${stationID}`;
  const headers = { Authorization: token };
  let payload = {};
  return async( dispatch ) => {
    dispatch({ type: START_REQUEST_SEARCH });

    await axios.get(url, { headers }).then(resp => {
      payload = {
        type: GET_CONTRACTS_CONDITIONS,
        payload: resp.data
      };
      dispatch(payload);
    }).catch(error => {
      const err = error.response?.data?.message.error;
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: {
          message: err ? err : "Error contacte al administrador",
          color: 'danger'
        }
      });
    });
    dispatch({ type: STOP_REQUEST_SEARCH });
  };
};

export const contractConditionSelected = (id) => {
  return {
    type: CONTRACT_CONDITION_SELECTED,
    payload: id
  };
};

export const addContractConditionMode = () => {
  return {
    type: ADD_CONTRACT_CONDITION_MODE,
  };
};

export const editContractConditionMode = () => {
  return {
    type: EDIT_CONTRACT_CONDITION_MODE,
  };
};

export const deleteContractConditionMode = () => {
  return {
    type: DELETE_CONTRACT_CONDITION_MODE,
  };
};

export const resetContractConditionSelected = () => {
  return {
    type: RESET_CONTRACT_CONDITION_SELECTED
  };
};

export const createNewContractCondition = (form, token) => {
  const url = `${process.env.REACT_APP_URL}/crm/contracts_conditions`;
  const headers = { Authorization: token };
  let payload = {};
  return async ( dispatch ) => {
    dispatch({ type: START_REQUEST_SEARCH });

    await axios.post(url, form, { headers }).then(resp => {
      payload = {
        type: CREATE_CONTRACT_CONDITION,
        payload: resp.data
      };
      dispatch(payload);
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: 'La condición de contrato se a creado con éxito', color: 'success' }
      });
    }).catch(error => {
      const err = error.response?.data?.message.error;
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: {
          message: err ? err : "Error contacte al administrador",
          color: 'danger'
        }
      });
    });
    dispatch({ type: STOP_REQUEST_SEARCH });
  };
};

export const editContractCondition = (id, form, token) => {
  const url = `${process.env.REACT_APP_URL}/crm/contracts_conditions/${id}`;
  const headers = { Authorization: token };
  let payload = {};
  return async ( dispatch ) => {
    dispatch({ type: START_REQUEST_SEARCH });

    await axios.put(url, form, { headers }).then(resp => {
      payload = {
        type: MOD_CONTRACT_CONDITION,
        payload: resp.data[0]
      };
      dispatch(payload);
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: 'La condición de contrato se a editado con éxito', color: 'success' }
      });
    }).catch(error => {
      const err = error.response?.data?.message.error;
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: {
          message: err ? err : "Error contacte al administrador",
          color: 'danger'
        }
      });
    });
    dispatch({ type: STOP_REQUEST_SEARCH });
  };
};

export const deleteContractCondition = (id, token) => {
  const url = `${process.env.REACT_APP_URL}/crm/contracts_conditions/${id}`;
  const headers = { Authorization: token };
  let payload = {};
  return async ( dispatch ) => {
    dispatch({ type: START_REQUEST_SEARCH });

    await axios.delete(url, { headers }).then(resp => {
      payload = {
        type: DELETE_CONTRACT_CONDITION,
        payload: resp.data[0].id
      };
      dispatch(payload);
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: { message: 'La condición de contrato se a eliminado con éxito', color: 'success' }
      });
    }).catch(error => {
      const err = error.response?.data?.message.error;
      dispatch({
        type: SET_SNACKBAR_SEARCH,
        payload: {
          message: err ? err : "Error contacte al administrador",
          color: 'danger'
        }
      });
    });
    dispatch({ type: STOP_REQUEST_SEARCH });
  };
};

export const clearContractsConditions = () => {
  return {
    type: CLEAR_CONTRACTS_CONDITIONS,
  };
};

export const clearOnlyContractsConditions = () => {
  return {
    type: CLEAR_ONLY_CONTRACTS_CONDITIONS,
  };
};